import { Component, Inject, inject } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
  MatSnackBarModule,
} from '@angular/material/snack-bar';
import { IconService } from '../../_services/icon.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-error-toast',
  templateUrl: './error-toast.component.html',
  styleUrls: ['./error-toast.component.scss'],
  standalone: true,
  imports: [MatIconModule, CommonModule, MatButtonModule],
})
export class ErrorToastComponent {
  snackBarRef = inject(MatSnackBarRef);
  iconService = inject(IconService);
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string; action: string }
  ) {
    this.iconService.getIcons(['DECLINA'], 'pratica-states');
  }
}
